export const I18N_SUPPORTED_LANGS = ["ru","en","zh","uk","ar","tr","es"]
export const I18N_DEFAULT_LANG = "en"
export const I18N_DICT_META = {
  "ru": {
    "keyCount": 6981,
    "hash": "034ad183f36cb419639ee317ac15eff08fe009a0ecbf0362178e18ae3dc17dea"
  },
  "en": {
    "keyCount": 6981,
    "hash": "1cf7a51d629dde5bb392536ac37864a6f12f234678a8b198066e4877d0612db2"
  },
  "zh": {
    "keyCount": 6981,
    "hash": "b4ccf968eb77000a0edcec7f2e6d55add865e3b9d63aa3c791c8dfa1457338fb"
  },
  "uk": {
    "keyCount": 6981,
    "hash": "f4da0b28175866da8398029ab8e21b20d480282020994a986812b179ce5bcf33"
  },
  "ar": {
    "keyCount": 6981,
    "hash": "1f0a31327bc8520079a0d917a33d1a8cac33463df128e74abef44ad9bdaa8142"
  },
  "tr": {
    "keyCount": 6981,
    "hash": "d2cc597d27bf7e91dd9d9b879d637bbe95228966246427386a10b862bd4b0356"
  },
  "es": {
    "keyCount": 6981,
    "hash": "c8ecca5d18ba1a5aa29cc31044c8581b1ac26607baae67018bbb35dfa02fef6e"
  }
}
